import { getProjectConfigFn, saveProjectConfigFn, sortProject } from '../api/v2/projectCtrl';
import apiProcess from "../api/utility";


/**
 * sort project
 *
 * @export
 * @param {string[]} projectIds
 * @returns promise
 */
export function sortProjectPromise(projectIds) {
  return apiProcess(sortProject, projectIds)
}

export function getProjectGenericConfig(projectId) {
  return apiProcess(getProjectConfigFn, projectId)
}

export function saveProjectGenericConfig({ projectId, updateType, settings }) {
  return apiProcess(saveProjectConfigFn, { projectId, updateType, settings })
}